export default __webpack_public_path__ + "jira.2751821f.png";